// Module
var code = `<style>:host{display:block;width:96px;height:36px;overflow:hidden;cursor:pointer}#wrapper{height:100%;width:100%;display:flex;align-items:center;justify-content:center}:host(:focus){outline:2px solid #0056b3}:host(:active){background-color:#0056b3}</style> <div id="wrapper"></div>`;
// Exports
export default code;